import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'bootstrap';
import SiteDocList from './SiteDocList';
import SectionHeader, { SectionHeaderTypes } from '../../Common/SectionHeader';

export default function SiteDocCategory({ category, onSelectDoc, viewDoc, downloadDoc, downloadAll }) {
    const [isClosed, setIsClosed] = useState(true);
    const tooltipList = useRef([]);
    useEffect(() => initializeTooltips(category), [category]);
    useEffect(() => handleAddResizeEvent(), []);


    function initializeTooltips(category) {
        const tooltipTriggerList = document.querySelectorAll(`.projectDocType[data-id="${category.key}"] .nameContainer[data-bs-toggle="tooltip"]`);
        const newTooltipList = [...tooltipTriggerList].map(el => {
            return { element: el, tooltip: new Tooltip(el) };
        });

        tooltipList.current = newTooltipList;

        return () => {
            // Dispose tooltips.
            newTooltipList.map(t => t.tooltip.dispose());
        };
    }

    function handleAddResizeEvent() {
        function handleResize() {
            const newTooltipList = tooltipList.current.map(x => {
                if (x.element.offsetWidth >= x.element.scrollWidth) {
                    x.tooltip.disable();
                }
                else {
                    x.tooltip.enable();
                }
                return x;
            });

            tooltipList.current = newTooltipList;
        }

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }

    let itemCount = `(${category.documents.length})`;
    let documents = !isClosed && (<SiteDocList
        categoryKey={category.key}
        documentList={category.documents}
        onSelectDoc={onSelectDoc}
        viewDoc={viewDoc}
        downloadDoc={downloadDoc}
        downloadAll={downloadAll} />);

    let selectCategory = onSelectDoc && (<span className="select cursor-pointer" onClick={() => onSelectDoc(category.key)}>
        <i className={`text-lg ${category.selected ? "dhicon-check-2" : "dhicon-check-empty"}`} />
    </span>);

    let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    let categoryName = category && (
        <SectionHeader sectionHeaderType={SectionHeaderTypes.Secondary} classes="justify-between">
            <div className="flex w-full items-center">
                {selectCategory}
                <span className="nameContainer flex w-full cursor-pointer"
                    onClick={() => setIsClosed(!isClosed)}
                    data-bs-toggle="tooltip" data-bs-placement="top"
                    data-bs-title={`${category.categoryName}`}>
                    <span className="name">{category.categoryName} {itemCount}</span>
                </span>
            </div>
            <i className={`icon ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />
        </SectionHeader>
    );

    return (
        <div className="projectDocTypeContainer">
            {categoryName}
            {documents}
        </div>
    );
}